import type { EducationCredential } from '../types/content';

export const educationCredential: EducationCredential = {
  qualification: 'Business Administration & Management',
  institution: 'The Open University'
};

export const governanceExposure: string[] = [
  'Board-level reporting and executive committee engagement',
  'European institutional engagement',
  'Corporate governance compliance',
  'International regulatory frameworks'
];
